export default __webpack_public_path__ + "static/media/zydus.5d2e9bda.png";